<template>
	<page class="page d-flex justify-center">
		<v-row
			v-if="project && project.subject"
			style="margin-top: -3%"
			align="start"
			class="project-name"
		>
			<v-col class="project-name--col d-flex justify-center">
				<div
					class="px-3 text-center white--text d-flex align-center justify-center"
				>
					{{ project.subject }}
				</div>
			</v-col>
		</v-row>
		<v-row
			class="align-conten"
			justify="center"
		>
			<v-col
				cols="9"
				sm="8"
				md="8"
				lg="6"
			>
				<v-row>
					<v-col>
						<close-app-logo color="dark" />
					</v-col>
				</v-row>
				<v-row style="margin-top: -7%">
					<v-col>
						<h2>הרשמה</h2>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-form
							ref="form"
							method="POST"
							action="http://payment.test/login"
						>
							<v-card-text>
								<smart-input
									v-model="form.email"
									:required="true"
									name="register"
									label="דואר אלקטרוני"
									:errors="errors.email"
									type="email"
								/>
								<smart-input
									id="password"
									v-model="form.password"
									required
									name="password"
									label="סיסמה"
									minlength="6"
									:errors="errors.password"
									type="password"
								/>
							</v-card-text>
							<v-row justify="center">
								<v-col>
									<v-alert
										v-if="showError"
										dense
										outlined
										type="error"
									>
										{{ errors.loginError }}
									</v-alert>
								</v-col>
							</v-row>
							<v-card-actions class="d-flex flex-column mt-8">
								<v-row>
									<v-col>
										<v-btn
											type="submit"
											class="btn"
										>
											המשך
										</v-btn>
									</v-col>
								</v-row>

								<v-row>
									<v-col>
										<a @click="gotoRegister">
											עוד לא נרשמתם? הרשמו עכשיו
										</a>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-form>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</page>
</template>

<script>
import { types } from "src/store/modules/Auth.module";
import PlanModule from "@/store/modules/Plan.module";
import CloseAppLogo from "@/components/CloseAppLogo";

export default {
	components: { CloseAppLogo },
	props: {
		admin: {
			type: Boolean,
		},
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: "",
		},
		errors: {},
	}),
	computed: {
		project () {
			return this.$store.state.ProjectModule.project;
		},
	},
	methods: {
		async googleLogin () {
			const selectedPlan = this.$store.state.PlanModule.selectedPlan;
			const response = await this.$store.dispatch(
				PlanModule.types.GET_PAYMENT_URL,
				selectedPlan.plan.id,
			);
			window.location = `/login/google?plan=${response}`;
		},
		async onSubmit () {
			this.showError = false;
			this.disabled = true;
			try {
				await this.$store.dispatch(
					types.LOGIN,
					this.form,
				);
			} catch (error) {
				this.errors = window.errorsBag;
				this.showError = true;
			}
		},
		gotoRegister () {
			this.$router.push({ path: `/signup?p=${this.$route.query.p}` });
		},
	},
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.page {
    width: 90%;
    margin: auto;
    background-color: $background;

    @include responsive($mobile) {
        max-width: $mobile !important;
        max-height: $mobile-height;
    }

    .project-name {
        &--col {
            padding: 0;

            div {
                height: 40px;
                width: 220px;
                background: #4595cc 0 0 no-repeat padding-box;
                border-radius: 0 0 20px 20px;
                opacity: 1;
            }
        }
    }
}
</style>
